import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SuperAdminLayout from '../components/SuperAdminLayout';
import '../styles/superadmin.css';

const BASE = 'https://menu.searchisend.in';

const GlobalNotifications = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('saas_superadmin_token');
    
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [url, setUrl] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [statusType, setStatusType] = useState('');

    useEffect(() => {
        if (!token) {
            navigate('/superadmin_v2_secure_login');
            return;
        }
    }, [token, navigate]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setImagePreview(reader.result);
            reader.readAsDataURL(file);
        } else {
            setImageFile(null);
            setImagePreview('');
        }
    };

    const handleSend = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatusMessage('');
        
        try {
            const formData = new FormData();
            formData.append('title', title);
            formData.append('message', message);
            if (url) formData.append('url', url);
            if (imageFile) formData.append('image', imageFile);

            const res = await fetch(`${BASE}/apimenu/v2/v2_super_dashboard.php?action=send_global_notification`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: formData
            });
            const data = await res.json();
            
            if (data.success) {
                setStatusMessage(data.message);
                setStatusType('success');
                setTitle(''); setMessage(''); setUrl(''); setImageFile(null); setImagePreview('');
                document.getElementById('image').value = '';
            } else {
                setStatusMessage(data.message);
                setStatusType('error');
            }
        } catch (err) {
            setStatusMessage('Network error occurred.');
            setStatusType('error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <SuperAdminLayout>
                    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                        <div style={{ marginBottom: '2rem' }}>
                            <h2 className="sa-page-title">Send Global Push Notification</h2>
                            <p className="sa-page-subtitle">Instantly reach all subscribers across all restaurants on the platform.</p>
                        </div>

                        <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                            <div className="sa-panel" style={{ flex: '1 1 500px', margin: 0 }}>
                                <div style={{ background: 'rgba(56, 189, 248, 0.1)', padding: '15px', borderRadius: 'var(--radius-sm)', borderLeft: '4px solid var(--info)', marginBottom: '2rem', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                    <i className="fas fa-broadcast-tower fa-2x" style={{ color: 'var(--info)' }}></i>
                                    <p style={{ color: 'var(--text-primary)', margin: 0, fontSize: '0.95rem', lineHeight: 1.5 }}>
                                        <strong>Use with caution.</strong> This message will be sent instantly to every end-user who has allowed push notifications for any restaurant.
                                    </p>
                                </div>

                                {statusMessage && (
                                    <div style={{
                                        padding: '12px 16px', borderRadius: 'var(--radius-sm)', marginBottom: '20px', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '10px',
                                        color: statusType === 'success' ? 'var(--success)' : 'var(--danger)',
                                        background: statusType === 'success' ? 'var(--success-bg)' : 'var(--danger-bg)',
                                        border: `1px solid ${statusType === 'success' ? 'var(--success)' : 'var(--danger)'}`
                                    }}>
                                        <i className={`fas ${statusType === 'success' ? 'fa-check-circle' : 'fa-exclamation-triangle'}`}></i>
                                        {statusMessage}
                                    </div>
                                )}

                                <form onSubmit={handleSend} className="sa-form-group">
                                    <div style={{ marginBottom: '1.5rem' }}>
                                        <label className="sa-form-label"><i className="fas fa-heading"></i> Notification Title (Required)</label>
                                        <input type="text" className="sa-input" style={{ width: '100%', background: 'var(--bg-dark)' }} value={title} onChange={(e) => setTitle(e.target.value)} required placeholder="e.g., Big Platform Update!" />
                                    </div>

                                    <div style={{ marginBottom: '1.5rem' }}>
                                        <label className="sa-form-label"><i className="fas fa-comment-alt"></i> Message Body (Required)</label>
                                        <textarea className="sa-input" rows="4" style={{ width: '100%', resize: 'vertical', background: 'var(--bg-dark)' }} value={message} onChange={(e) => setMessage(e.target.value)} required placeholder="What do you want to tell everyone?"></textarea>
                                    </div>

                                    <div style={{ marginBottom: '1.5rem' }}>
                                        <label className="sa-form-label"><i className="fas fa-link"></i> Clickable URL (Optional)</label>
                                        <input type="text" className="sa-input" placeholder="https://yourlink.com" style={{ width: '100%', background: 'var(--bg-dark)' }} value={url} onChange={(e) => setUrl(e.target.value)} />
                                    </div>

                                    <div style={{ marginBottom: '2.5rem' }}>
                                        <label className="sa-form-label"><i className="fas fa-image"></i> Banner Image (Optional)</label>
                                        <div style={{ border: '2px dashed var(--border-color)', padding: '15px', borderRadius: 'var(--radius-sm)', background: 'var(--bg-dark)', transition: 'all 0.2s' }}>
                                            <input type="file" id="image" accept="image/*" onChange={handleFileChange} style={{ color: 'var(--text-secondary)', display: 'block', width: '100%' }} />
                                        </div>
                                    </div>

                                    <button type="submit" className="sa-primary-btn" style={{ width: '100%', padding: '15px', fontSize: '1.1rem', background: 'var(--accent-primary)', border: 'none' }} disabled={isLoading}>
                                        {isLoading ? <><i className="fas fa-circle-notch fa-spin"></i> Broadcasting...</> : <><i className="fas fa-paper-plane"></i> Send Notification to All Users</>}
                                    </button>
                                </form>
                            </div>

                            <div className="sa-panel" style={{ flex: '1 1 350px', margin: 0, background: 'var(--bg-dark)', borderColor: 'var(--border-color)', borderStyle: 'dashed', borderWidth: '2px' }}>
                                <h4 className="sa-panel-title" style={{ borderBottom: 'none', marginBottom: '5px', padding: 0 }}><i className="fas fa-mobile-alt"></i> Live Preview</h4>
                                <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '20px' }}>This is a simulation of how it may appear on devices.</p>
                                
                                <div style={{ background: '#ffffff', borderRadius: '16px', padding: '16px', display: 'flex', gap: '12px', alignItems: 'flex-start', boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }}>
                                    <img src="https://searchisend.in/scalogo.png" alt="icon" style={{ width: '45px', height: '45px', borderRadius: '10px', flexShrink: 0, border: '1px solid #f0f0f0' }} />
                                    <div style={{ flexGrow: 1, textAlign: 'left', overflow: 'hidden' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                                            <p style={{ fontWeight: 600, color: '#111111', margin: 0, fontSize: '0.95rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title || 'Notification Title'}</p>
                                            <span style={{ fontSize: '0.7rem', color: '#888' }}>now</span>
                                        </div>
                                        <p style={{ fontSize: '0.85rem', color: '#555555', margin: 0, lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{message || 'Your message preview will appear here.'}</p>
                                        
                                        {imagePreview && (
                                            <div style={{ width: '100%', aspectRatio: '2 / 1', overflow: 'hidden', borderRadius: '8px', marginTop: '12px', backgroundColor: '#f5f5f5', border: '1px solid #eaeaea' }}>
                                                <img src={imagePreview} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        </SuperAdminLayout>
    );
};

export default GlobalNotifications;

